import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ecf0f3;
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: ${stylesGlobalDefault.blackMenu1};
  width: 100%;
  min-height: 80px;

  @media (max-width: 1366px) and (max-height: 768px) {
    width: 100%;
    min-height: 20px;
    overflow: hidden;
  }
`;

export const Title = styled.div`
  width: 400px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-weight: 700;
  font-size: 18px;
  color: ${stylesGlobalDefault.white};

  @media (max-width: 1366px) and (max-height: 768px) {
    font-size: 12px;
    overflow: hidden;
  }
`;

export const Subtitle = styled.div`
  width: 400px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-weight: 300;
  font-size: 14px;
  padding-left: 20px;
  padding-top: 4px;
  color: #ccc;
`;

export const ContainerDescription = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
`;

export const FooterContainer = styled.div`
  width: 100%;
  min-height: 80px;
  background: ${stylesGlobalDefault.blackMenu1};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;

  @media (max-width: 1366px) and (max-height: 768px) {
    min-height: 60px;
    overflow: hidden;
  }
`;

export const BodyContainer = styled.div`
  width: 100%;
  height: calc(100vh - 140px);

  @media (max-width: 1366px) and (max-height: 768px) {
    width: 100%;
    height: calc(88vh - 100px);
    overflow: hidden;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  `;

  export const MenuListWrapper = styled.div`
    margin-right: 16px;
    width: 400px;
    font-size: 14px;
    background: ${stylesGlobalDefault.white};
    border-radius: 8px;
    padding: 4px 8px;
  
  
    @media (max-width: 1366px) and (max-height: 768px) {
      width: 360px;
      font-size: 12px;
    }
  `;

export const ButtonFinish = styled.button<{
  color?: "primary" | "forth";
  onClick?: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  border-radius: 50px;
  outline: none;
  transition: all 0.2s;
  min-width: 185px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17.5px;
  margin-right: 20px;
  transition: opacity 0.2s;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};

  &:hover {
    opacity: ${(props) => (props.disabled ? 0.5 : 0.8)};
  }
  
  ${(props) =>
    props.color === "primary" &&
    css`
      color: ${stylesGlobalDefault.white};
      background: ${(props as any).disabled
        ? "#ccc"
        : stylesGlobalDefault.orange};
    `}
    
    ${(props) =>
    props.color === "forth" &&
    css`
      color: ${stylesGlobalDefault.white};
      background: ${(props as any).disabled
        ? "#ccc"
        : stylesGlobalDefault.blue};
    `}
    `;
